import { render, staticRenderFns } from "./WorkAuthorization.vue?vue&type=template&id=5f363fe9&scoped=true&"
import script from "./WorkAuthorization.vue?vue&type=script&lang=js&"
export * from "./WorkAuthorization.vue?vue&type=script&lang=js&"
import style0 from "./WorkAuthorization.vue?vue&type=style&index=0&id=5f363fe9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f363fe9",
  null
  
)

export default component.exports